// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__AfvSo","empty":"ModalGraph_empty__3IqbF"};